import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../features/uiStatus/components/Loading';
import { pageShell } from '../styles/pageShell';
import { typeShell } from '../styles/typeShell';

const SettingsCard = ({
    icon,
    title,
    description,
    headerAside = null,
    children,
    loading = false,
    className = ''
}) => {
    if (loading) {
        return (
            <div className={`${pageShell.cardFit} text-center ${className}`.trim()}>
                <Loading isLoading />
            </div>
        );
    }

    return (
        <div className={`${pageShell.cardFit} !p-0 ${className}`.trim()}>
            <div className="flex flex-col items-center gap-3 border-0 border-b border-solid border-border bg-surface/[0.02] px-card py-3 text-center bp-lg:flex-row bp-lg:items-center bp-lg:text-left">
                {icon && (
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-10 text-accent">
                        <span className={pageShell.sectionIcon}>{icon}</span>
                    </div>
                )}
                <div className="min-w-0 flex-1">
                    {title && (
                        <h3 className={`${pageShell.sectionTitle} mb-1 justify-center bp-lg:justify-start`}>
                            {title}
                        </h3>
                    )}
                    {description && (
                        <p className={`m-0 leading-snug ${typeShell.muted}`}>
                            {description}
                        </p>
                    )}
                </div>
                {headerAside && (
                    <div className={`${pageShell.headerAside} w-full justify-end bp-lg:ml-auto bp-lg:w-auto`}>
                        {headerAside}
                    </div>
                )}
            </div>
            <div className="flex flex-1 flex-col p-card">
                {children}
            </div>
        </div>
    );
};

SettingsCard.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    headerAside: PropTypes.node,
    children: PropTypes.node,
    loading: PropTypes.bool,
    className: PropTypes.string
};

export default SettingsCard;
